export class AdminIdeasDraftDeleteRequest {
  ideaId: string

  constructor(ideaId: string) {
    this.ideaId = ideaId
  }
}
